<div class="table-results-wrap mb-2">
  <div class="results-actions">
    <mat-slide-toggle
      (change)="showHomeworkResults($event)"
      color="primary"
      class="mat-step-label mb-2 pl-1 d-block w-auto">
      Добавить в таблицу итоговый результат домашних работ за каждый месяц
    </mat-slide-toggle>

    <mat-slide-toggle
      (change)="showControlWorksResults($event)"
      color="primary"
      class="mat-step-label mb-2 pl-1 d-block w-auto">
      Добавить в таблицу итоговый результат контрольных работ за каждый месяц
    </mat-slide-toggle>

    <mat-slide-toggle
      *ngIf="data && data.esdp_results.length > 0"
      (change)="showESDPResults($event)"
      color="primary"
      class="mat-step-label mb-2 pl-1 d-block w-auto">
      Отобразить успеваемость за каждый период ESDP
    </mat-slide-toggle>

    <mat-slide-toggle
      *ngIf="data && data.esdp_results.length > 0"
      (change)="showESDPReview($event)"
      color="primary"
      class="mat-step-label mb-2 pl-1 d-block w-auto">
      Отобразить рецензию ESDP от наставника
    </mat-slide-toggle>
  </div>

  <table
    mat-table
    *ngIf="data"
    [dataSource]="data.results"
    class="table-results w-100 mat-elevation-z2 purple-medium-dark-theme-section mb-2">
    <ng-container matColumnDef="month">
      <th mat-header-cell *matHeaderCellDef>
        <span class="font-weight-bold"> Месяц </span>
      </th>
      <td mat-cell *matCellDef="let dataItem">
        Месяц {{ dataItem.period.number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="theme">
      <th mat-header-cell *matHeaderCellDef>
        <span class="font-weight-bold">Тема</span>
      </th>
      <td mat-cell *matCellDef="let dataItem">
        {{ dataItem.period.theme || 'Тема не указана' }}
      </td>
    </ng-container>

    <ng-container *ngIf="showHomeworkResults$ | async" matColumnDef="homeworks">
      <th mat-header-cell *matHeaderCellDef>
        <span class="font-weight-bold">Домашние работы</span>
      </th>
      <td mat-cell *matCellDef="let dataItem">
        {{ dataItem.homework_points }}%
      </td>
    </ng-container>

    <ng-container
      *ngIf="showControlWorksResults$ | async"
      matColumnDef="control-works">
      <th mat-header-cell *matHeaderCellDef>
        <span class="font-weight-bold">Контрольные работы</span>
      </th>
      <td mat-cell *matCellDef="let dataItem">{{ dataItem.exam_point }}%</td>
    </ng-container>

    <ng-container matColumnDef="result">
      <th mat-header-cell *matHeaderCellDef>
        <span class="font-weight-bold">Итог</span>
      </th>
      <td mat-cell *matCellDef="let dataItem">{{ dataItem.result }}%</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<div *ngIf="showESDPResults$ | async" class="table-results-wrap mb-2">
  <table
    *ngIf="data"
    class="table-results mat-elevation-z2 w-100 mat-table purple-medium-dark-theme-section">
    <tr class="mat-header-row">
      <th class="mat-header-cell text-center font-weight-bold mat-column-month">
        Месяц ESDP
      </th>
      <th class="mat-header-cell text-center font-weight-bold">Дата</th>
      <th
        class="mat-header-cell text-center font-weight-bold mat-column-result">
        Итог
      </th>
    </tr>

    <tr *ngFor="let esdp of data.esdp_results; let i = index" class="mat-row">
      <td class="mat-cell mat-column-month text-center">Месяц {{ i + 1 }}</td>
      <td class="mat-cell text-center">
        {{ esdp.period.start_date }} - {{ esdp.period.finish_date }}
      </td>
      <td class="mat-cell text-center mat-column-result">{{ esdp.result }}</td>
    </tr>
  </table>
</div>

<div
  *ngIf="data.mentor_note && (showESDPReview$ | async)"
  class="mentor-note-wrap mat-elevation-z2 purple-medium-dark-theme-section mb-3">
  <div
    class="froala-view p-4 content"
    [froalaView]="data.mentor_note.text"></div>
  <h6 class="text-right mt-3">
    - Наставник <b>{{ data.mentor_note.writer.full_name }}</b>
    <span class="ml-2 mr-4 mentor-note-date">{{ data.mentor_note.date }}</span>
  </h6>
  <hr />
</div>

<div class="table-results-wrap">
  <table
    *ngIf="data"
    class="table-results mat-elevation-z2 w-100 mat-table purple-medium-dark-theme-section">
    <tr class="mat-header-row">
      <th class="mat-header-cell text-center font-weight-bold">
        <span class="d-block">Итоговая оценка</span>
        ({{ data.results[0].period.number }} -
        {{ data.results[data.results.length - 1].period.number }} месяц)
      </th>
      <th
        *ngIf="data.exam !== null"
        class="mat-header-cell text-center font-weight-bold">
        Итоговая контрольная
      </th>
      <th
        *ngIf="
          data.esdp_results.length !== 0 &&
          data.esdp_score !== 0 &&
          data.group.is_esdp
        "
        class="mat-header-cell text-center font-weight-bold">
        Оценка наставника
      </th>
      <th class="mat-header-cell text-center font-weight-bold">Итог</th>
    </tr>

    <tr class="mat-row">
      <td class="mat-cell text-center">{{ data.before_esdp_score }}%</td>
      <td *ngIf="data.exam !== null" class="mat-cell text-center">
        {{ data.exam }}%
      </td>
      <td
        class="mat-cell text-center"
        *ngIf="
          data.esdp_results.length !== 0 &&
          data.esdp_score !== 0 &&
          data.group.is_esdp
        ">
        {{ data.esdp_score }}%
      </td>
      <td class="mat-cell text-center">{{ data.score }}%</td>
    </tr>
  </table>
</div>
